(function ($) {
    document.addEventListener('DOMContentLoaded', function () {

        const about__slider = document.querySelector('.about-carousel__slider');
        if (about__slider) {
            const about__numCircles = document.querySelectorAll('.about-carousel__item-default_circle');
            const about__swiper = new Swiper(about__slider, {
                slidesPerView: 1,
                speed: 1200,
                pagination: {
                    el: ".about-carousel__slider-wrapper .swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: '.about-carousel__slider-nav .slider-button-next',
                    prevEl: '.about-carousel__slider-nav .slider-button-prev',
                },
            });

            for (let i = 0; i < about__numCircles.length; i++) {
                const swiperSlide = about__numCircles[i].closest('.swiper-slide');
                about__numCircles[i].addEventListener('click', function () {
                    about__swiper.slideTo(about__swiper.slides.indexOf(swiperSlide));
                });
            }
        }

        const partners__slider = document.querySelector('.partners__slider');
        if (partners__slider) {
            const partners__swiper = new Swiper(partners__slider, {
                slidesPerView: 'auto',
                speed: 500,
                pagination: {
                    el: ".partners__slider-wrapper .swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: '.partners__slider-wrapper .slider-button-next',
                    prevEl: '.partners__slider-wrapper .slider-button-prev',
                },
            });
        }

    });
})(jQuery);
